import { styled } from 'twin.macro';

const MarkdownParagraph = styled.p``;

export default MarkdownParagraph;
